import { render, staticRenderFns } from "./MessageSignature.vue?vue&type=template&id=37975b58&"
import script from "./MessageSignature.vue?vue&type=script&lang=js&"
export * from "./MessageSignature.vue?vue&type=script&lang=js&"
import style0 from "./MessageSignature.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37975b58')) {
      api.createRecord('37975b58', component.options)
    } else {
      api.reload('37975b58', component.options)
    }
    module.hot.accept("./MessageSignature.vue?vue&type=template&id=37975b58&", function () {
      api.rerender('37975b58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/profile/MessageSignature.vue"
export default component.exports